module.exports = __webpack_public_path__ + "static/img/04.0e98376.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/04.png
// module id = NVpO
// module chunks = 1